import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index.js'
import Login from '../views/Login.vue'
import Inbox from '../views/Inbox.vue'
import Toolbar from '../views/Toolbar.vue'
import AddItem from '../views/AddItem.vue'
import Setting from '../views/Setting.vue'
import AddVendor from '../views/AddVendor.vue'
import SelectedBiz from '../views/SelectedBiz.vue'
import BudgetInbox from '../views/BudgetInbox.vue'
import DashboardMemo from '../views/DashboardMemo.vue'
import DashboardBudget from '../views/DashboardBudgetPermission.vue'
import DashboardBudgetV2 from '../views/DashboardBudgetPermissionV2.vue'
import CreatePurchaseRequisition from '../views/CreatePurchaseRequisition.vue'
import Landing from '../views/LandingPage.vue'
import CreateCStoPO from '../views/CreateCStoPO.vue'
import CreateWaitQT from '../views/CreateWaitQT.vue'
import InboxCStoPO from '../views/InboxCStoPO.vue'
import InboxCStoPODetail from '../views/InboxCStoPODetail.vue'
import AllDocumentCStoPO from '../views/AllDocumentCstoPO.vue'
import CreateCSPO from '../views/CreateCSPO.vue'
import CreateCSPOWaitQT from '../views/CreateCSPOWaitQT.vue'
import DbEstimateCost from '../views/DbEstimateCost.vue'
import CutPettyCash from '../views/CutPettyCash.vue'
import EvaluateVendorDetail from '@/components/EvaluateVendorDetail.vue'
import EvalVendor from '../views/EvalVendor.vue'
import EvalVendorReport from '../views/ReportEvalVendor.vue'
import EvalVendorSummary from '../views/ReportSummaryEvalVendor.vue'
import SummaryFinance from '../views/SummaryFinance.vue'
import AddGlAccount from '../views/AddGLAccount.vue'

Vue.use(VueRouter)


const routes = [
  {
    path: '',
    name: 'toolbar',
    component: Toolbar,
    redirect: { name: 'login' } ,
    children: [
      {
        path: '/selected_business',
        name: 'selected_business',
        meta: { requiresAuth: true },
        component: SelectedBiz
      },
      {
        path: '/create_purchase',
        name: 'create_purchase',
        meta: { requiresAuth: true, checkSelectedBiz: true },
        component: CreatePurchaseRequisition
      },
      {
        path: '/inbox',
        name: 'inbox',
        meta: { requiresAuth: true, checkSelectedBiz: true },
        component: Inbox
      },
      {
        path: '/add_item',
        name: 'add_item',
        meta: { requiresAuth: true, checkSelectedBiz: true },
        component: AddItem
      },
      {
        path: '/add_vendor',
        name: 'add_vendor',
        meta: { requiresAuth: true, checkSelectedBiz: true },
        component: AddVendor
      },
      {
        path: '/setting',
        name: 'setting',
        meta: { requiresAuth: true },
        component: Setting
      },
      {
        path: '/inbox/purchase_detail',
        name: 'purchase_detail',
        meta: { requiresAuth: true, checkSelectedBiz: true },
        component: CreatePurchaseRequisition
      },
      {
        path: '/budget_inbox',
        name: 'budget_inbox',
        meta: { requiresAuth: true },
        component: BudgetInbox,
      },
      {
        path: '/dashboard_budget',
        name: 'dashboard_budget',
        meta: { requiresAuth: true },
        component: DashboardBudget,
        props:route => ({ ...route.query })
      },
        {
        path: '/dashboard_budgetV2',
        name: 'dashboard_budgetV2',
        meta: { requiresAuth: true },
        component: DashboardBudgetV2,
        props:route => ({ ...route.query })
      },
      {
        path: '/dashboard_memo',
        name: 'dashboard_memo',
        meta: { requiresAuth: true },
        component: DashboardMemo,
      },
      {
        path: '/create_cs_to_po',
        name: 'create_cs_to_po',
        meta: { requiresAuth: true, checkSelectedBizINET: true },
        component: CreateCStoPO,
      },
      {
        path: '/create_cs_po',
        name: 'create_cs_po',
        meta: { requiresAuth: true, checkSelectedBizINET: true },
        component: CreateCSPO,
      },
      {
        path: '/create_wait_qt',
        name: 'create_wait_qt',
        meta: { requiresAuth: true, checkSelectedBizINET: true },
        component: CreateWaitQT,
      },
      {
        path: '/create_cspo_wait_qt',
        name: 'create_cspo_wait_qt',
        meta: { requiresAuth: true, checkSelectedBizINET: true },
        component: CreateCSPOWaitQT,
      },
      {
        path: '/inbox_cs_po',
        name: 'inbox_cs_po',
        meta: { requiresAuth: true, checkSelectedBizINET: true },
        component: InboxCStoPO,
      },
      {
        path: '/inbox_cs_po/purchase_detail',
        name: 'inbox_cs_po_detail',
        meta: { requiresAuth: true, checkSelectedBizINET: true },
        component: InboxCStoPODetail,
      },
      {
        path: '/all_document_cs_po',
        name: 'all_document_cs_po',
        meta: { requiresAuth: true, checkSelectedBizINET: true },
        component: AllDocumentCStoPO,
      },
      {
        path: '/db_estimate_cost',
        name: 'db_estimate_cost',
        meta: { requiresAuth: true },
        component: DbEstimateCost,
      },
      {
        path: '/cut_petty_cash',
        name: 'cut_petty_cash',
        meta: { requiresAuth: true },
        component: CutPettyCash,
      },
      {
        path: "/eval_vendor_detail",
        name: "eval_vendor_detail",
        meta: { requiresAuth: true },
        component: EvaluateVendorDetail,
      },
      {
        path: '/eval_vendor',
        name: 'eval_vendor',
        meta: { requiresAuth: true },
        component: EvalVendor,
      },
      {
        path: '/report_eval_vendor',
        name: 'report_eval_vendor',
        meta: { requiresAuth: true },
        component: EvalVendorReport,
      },
      {
        path: '/summary_eval_vendor',
        name: 'summary_eval_vendor',
        meta: { requiresAuth: true },
        component: EvalVendorSummary,
      },
      {
        path: '/summary_finance',
        name: 'summary_finance',
        meta: { requiresAuth: true },
        component: SummaryFinance,
      },
      {
        path: '/add_gl_account',
        name: 'add_gl_account',
        component: AddGlAccount,
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/landing', //landing page from bot to web view
    name: 'landing',
    component: Landing,
    props:route => ({ ...route.query }) //collected query after question mark ex. landing?shared_token=...
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  if (to.matched.some(record => record.meta.checkSelectedBiz)) {
    if(Object.keys(store.getters['confirmSelectedBiz']).length) {
      next()
    } else {
      // store.dispatch('clearAll')
      // sessionStorage.clear()
      next({ name: "selected_business" });
      return;
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    const access_token  = store.getters['accessToken']
    const countRaDetail = Object.keys(store.getters['raDetail']).length
    if (!access_token || !countRaDetail) {
      next({ name: 'login' })
    } else {
      next()
    }
  } else {
    next()
  }
  if (to.matched.some(record => record.meta.checkSelectedBizINET)) {
    if(store.getters['confirmSelectedBiz'].tax_id == '0107544000094') {
      next()
    } else {
      next({name: 'selected_business'})
    }
  }
})
export default router
